<template>
  <!--
      	作者：fzf
      	时间：2025-7-10
      	描述：插件中心-客服中心
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="课程管理" name="material">
                    <Material v-if="activeName=='material'"></Material>
                </el-tab-pane>
                <el-tab-pane label="分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Material from './material/Index.vue';
    import Category from './category/Index.vue';
    export default {
        components: {
            Material,
            Category,
        },
        data() {
          return {
              activeName: 'material',
              /*是否加载完成*/
              loading: true,
          }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/material5/index.vue